class ScrollAnimation {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.item = self.elem.querySelector('[data-sticky-bar-item]');
        self.trigger = self.elem.querySelector('[data-sticky-bar-trigger]');
    }

    init() {
        let self = this;

        // self.stickyNav();
    }

    stickyNav() {
        let self = this;

        document.addEventListener('scroll', (e) => {
            if (window.scrollY > self.trigger.offsetTop) {
                self.item.classList.add('is-sticky');
            } else {
                self.item.classList.remove('is-sticky');
            }
        });
    }
}

export default ScrollAnimation;
